import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ajaxUtils } from '@nestech/utils';
import { catchError, Observable } from 'rxjs';
import { ApiUrl, isApiUrl } from './api-url';

const defaultResponseType: 'json' = 'json' as const;
const defaultHttpHeaders: Record<string, string | string[]> = { 'Content-Type': 'application/json' };

const encodeUrl = (url: ApiUrl): string =>
  `/api/${ajaxUtils.encodeQueryParameters(url.split('/api/')?.[1] || url.split('api/')?.[1])}`;

const isXML = <T extends { toOrigin: () => any }>(value: any): value is T => !!value?.toOrigin;

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (isApiUrl(request.url)) {
      const apiUrl: ApiUrl = request.url;
      const body = isXML(request.body) ? request.body.toOrigin()?.xml.product || request.body.toOrigin() : request.body;
      const skipContentType = body instanceof FormData;

      const clone = request.clone({
        url: encodeUrl(apiUrl),
        responseType: request.responseType || defaultResponseType,
        setHeaders: { ...(skipContentType ? {} : defaultHttpHeaders) },
        body,
      });
      return next.handle(clone).pipe(
        catchError(error => {
          throw error;
        }),
      );
    }
    return next.handle(request);
  }
}
